import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import { ListeTable } from '@mairistem/liste';

import type { ArreteType } from '@/types';
import { formatMonetaire, getRegieRegisseurFullName } from '@/utils';

interface ArreteAnnuelListeTableRowProps {
  item: ArreteType;
  rowProps: Record<string, unknown>;
}

const ArreteAnnuelListeTableRow = (props: ArreteAnnuelListeTableRowProps) => {
  const { item, rowProps } = props;

  const { identifiant, date, libelle, regisseur, montantTotal, montantTotalAnnulation } = item;

  const sansEncaissement = !montantTotal || montantTotal === 0;
  const aDesAnnulations = montantTotalAnnulation && montantTotalAnnulation > 0;
  const montantTitle =
    sansEncaissement && aDesAnnulations
      ? `L'arrêté du ${dayjs(date).locale('fr').format('D MMMM YYYY')} est sans encaissement. Des annulations de reçus ont été saisies pour un montant de ${formatMonetaire(montantTotalAnnulation, 2, true)}.`
      : undefined;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="libelle"
        verticalAlign="middle"
        // @ts-expect-error title attribute supporté par le rendu HTML
        title={libelle}
      >
        <div className="textEllipsis" style={{ paddingRight: 10 }}>
          {libelle}
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell name="date" textAlign="center" verticalAlign="middle" style={{ width: 160 }}>
        {dayjs(date).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell name="regisseur" verticalAlign="middle" style={{ width: 250 }}>
        {getRegieRegisseurFullName(regisseur)}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="montantTotal"
        textAlign="right"
        verticalAlign="middle"
        style={{ width: 180 }}
        // @ts-expect-error
        title={montantTitle}
      >
        {formatMonetaire(montantTotal ?? 0)}
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ArreteAnnuelListeTableRow;
